import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import { IJobOpening, ICreateJobOpening, IUpdateJobOpening, JobApplicationStatuses, IJobApplication } from "./types"

export const getVacancies = (): Promise<AxiosResponse<IJobOpening[]>> => {
    return apiInstance.handler.get<IJobOpening[]>(`/job-openings`)
}
export const getVacancy = (id: string): Promise<AxiosResponse<IJobOpening>> => {
    return apiInstance.handler.get<IJobOpening>(`/job-openings/${id}`)
}
export const createVacancy = (data: ICreateJobOpening): Promise<AxiosResponse<IJobOpening>> => {
    return apiInstance.handler.post<IJobOpening>(`/job-openings`, data)
}
export const updateVacancy = (id: string, data: IUpdateJobOpening): Promise<AxiosResponse<IJobOpening>> => {
    return apiInstance.handler.put<IJobOpening>(`/job-openings/${id}`, data)
}
export const deleteVacancy = (id: string): Promise<AxiosResponse> => {
    return apiInstance.handler.delete(`/job-openings/${id}`)
}
export const getJobApplications = (status: JobApplicationStatuses): Promise<AxiosResponse<IJobApplication[]>> => {
    return apiInstance.handler.get<IJobApplication[]>(`/job-applications`, {
        params: {
            status
        }
    })
}
export const rejectJobApplication = (id: string, comment: string): Promise<AxiosResponse> => {
    return apiInstance.handler.post(`/job-applications/${id}/reject`, { comment })
}
export const approveJobApplication = (id: string): Promise<AxiosResponse> => {
    return apiInstance.handler.post(`/job-applications/${id}/approve`)
}